import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { FiFileText, FiDownload } from "react-icons/fi"

import {
  getCourseMaterials,
  downloadMaterial,
} from "../../../services/operations/materialAPI"

const formatSize = (bytes) => {
  if (!bytes) return ""
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

//Downloads for an enrolled student. The list carries no file urls...each download
//is fetched through the api with the auth token and saved from the response, so
//there is no link here for anyone to copy and pass on.
const CourseMaterials = () => {
  const { courseId } = useParams()
  const { token } = useSelector((state) => state.auth)

  const [materials, setMaterials] = useState([])
  const [loading, setLoading] = useState(true)
  const [downloading, setDownloading] = useState(null)

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      setMaterials((await getCourseMaterials(courseId, token)) ?? [])
      setLoading(false)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId])

  const handleDownload = async (material) => {
    setDownloading(material._id)
    await downloadMaterial(courseId, material, token)
    setDownloading(null)
  }

  if (loading) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    )
  }

  return (
    <div className="py-10">
      <h1 className="text-3xl font-semibold text-richblack-5">Course materials</h1>
      <p className="mt-2 text-richblack-300">
        Notes and files shared by your instructor.
      </p>

      {materials.length === 0 ? (
        <p className="mt-16 text-center text-xl text-richblack-100">
          Your instructor has not added any materials yet.
        </p>
      ) : (
        <div className="mt-8 flex flex-col gap-3">
          {materials.map((material) => (
            <div
              key={material._id}
              className="flex items-center justify-between gap-4 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-5"
            >
              <div className="flex min-w-0 items-center gap-4">
                <FiFileText className="shrink-0 text-2xl text-yellow-50" />
                <div className="min-w-0">
                  <p className="truncate text-lg font-medium text-richblack-5">
                    {material.title}
                  </p>
                  {material.description && (
                    <p className="truncate text-sm text-richblack-300">
                      {material.description}
                    </p>
                  )}
                  <p className="mt-1 text-xs text-richblack-400">
                    {material.originalName} {formatSize(material.bytes)}
                  </p>
                </div>
              </div>

              <button
                onClick={() => handleDownload(material)}
                disabled={downloading === material._id}
                className="flex shrink-0 items-center gap-2 rounded-md bg-yellow-50 px-5 py-2 font-semibold text-richblack-900 disabled:opacity-60"
              >
                <FiDownload />
                {downloading === material._id ? "Downloading..." : "Download"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default CourseMaterials
